import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { AfterViewInit, ChangeDetectorRef, Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NgScrollbar } from 'ngx-scrollbar';
import { finalize, map, tap } from 'rxjs';
import { DialogFiltroGenericoComponent } from 'src/app/components/dialog-filtro-generico/dialog-filtro-generico.component';
import { Filters } from 'src/app/components/lista-tabellare/classes/lista-tabellare-data-source';
import {
  AzioneBP,
  AzioneEBuonaPraticaService,
} from 'src/app/services/azione-e-buona-pratica/azione-e-buona-pratica.service';
import { KPI, KPIService } from 'src/app/services/KPI/kpi.service';
import { SettoriService } from 'src/app/services/settori/settori.service';
import { UtilityService } from 'src/app/services/utility/utility.service';

@Component({
  selector: 'app-dialog-cfg-risposte-tematica',
  standalone: false,

  templateUrl: './dialog-cfg-risposte-tematica.component.html',
  styleUrl: './dialog-cfg-risposte-tematica.component.scss',
})
export class DialogCfgRisposteTematicaComponent implements AfterViewInit {
  @ViewChild('scrollDisponibili') scrollDispobibili!: NgScrollbar;
  @ViewChild('scrollSelezionate') scrollSelezionate!: NgScrollbar;
  @ViewChild('scrollDialog') scrollDialog!: NgScrollbar;

  public arrayKpiSelFiltrati: KPI[] = [];
  public arrayKpiSel: KPI[] = [];
  public arrayKpi: KPI[] = [];

  public arrayAzioneBPSelFiltrati: AzioneBP[] = [];
  public arrayAzioneBPSel: AzioneBP[] = [];
  public arrayAzioneBP: AzioneBP[] = [];

  private _valoriFiltro: Filters[] = [];
  private _valoriFiltroSelezionati: Filters[] = [];

  private _filtri: { [key: string]: any }[] = [];

  public loadingDisponibili: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<DialogCfgRisposteTematicaComponent>,
    private readonly kpiService: KPIService,
    private readonly azioniBPService: AzioneEBuonaPraticaService,
    private readonly settoriService: SettoriService,
    public dialog: MatDialog,
    private readonly cdRef: ChangeDetectorRef,
    private readonly utilityService: UtilityService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      elemento: string;
      titolo: string;
      arraySelezioinati: any[];
      isVsme: boolean;
    },
  ) {}

  ngAfterViewInit(): void {
    this._valoriFiltro = [];
    this._valoriFiltroSelezionati = [];

    switch (this.data.elemento) {
      case 'azione':
        this.arrayAzioneBPSel = this.data.arraySelezioinati;
        this._getAzioniBP();
        break;
      case 'kpi':
        this.arrayKpiSel = this.data.arraySelezioinati;
        this._getkPI();
        break;
      default:
        break;
    }

    this.rimpiArraySelezionati(this.data.elemento);

    this.cdRef.detectChanges();
  }

  /**
   * Metodo che mi crea un oggetto per visualizzare i dati nel componente di chip
   * @param getTags
   * @returns
   */
  private metodoGetTagsPerChip(getTags: any) {
    return (ricerca: string | undefined, elementiPreSelezionati?: string[]) =>
      this.utilityService._getTagsPerFiltro(ricerca, elementiPreSelezionati, getTags).pipe(
        map((tags: string[]) =>
          tags.map((tag, index) => ({
            id: index,
            descrizione: tag,
          })),
        ),
      );
  }

  public apriFiltroSelezionati(filtroFrom: string) {
    // Uso un oggetto per mappare i casi e le funzioni corrispondenti
    const filterActions = {
      azione: () =>
        this._configuraFiltri(
          'titoloFiltroSelezione',
          'tagFiltroSelezione',
          'settoreFiltroSelezione',
          this.metodoGetTagsPerChip(this.azioniBPService.getAzioneBPTags(0, 1000)),
        ),
      kpi: () =>
        this._configuraFiltri(
          'descrizioneFiltroSelezione',
          'tagFiltroSelezione',
          'settoreFiltroSelezione',
          this.metodoGetTagsPerChip(this.kpiService.getKPITags(0, 1000)),
        ),
    };

    // Tipo per le chiavi dell'oggetto filterActions
    type FilterActionsKey = keyof typeof filterActions;

    // Verifica se la chiave fornita è valida
    if (filtroFrom in filterActions) {
      this._filtri = filterActions[filtroFrom as FilterActionsKey]();
    }

    const dialogFiltro = this.dialog.open(DialogFiltroGenericoComponent, {
      data: {
        filtri: this._filtri,
        valoriFiltro: this._valoriFiltroSelezionati,
      },
      panelClass: ['dialog-container'],
      disableClose: false,
      width: '50%',
      maxHeight: '95%',
      autoFocus: false,
    });

    dialogFiltro.afterClosed().subscribe((result) => {
      if (result) {
        this._valoriFiltroSelezionati = result.filtri;

        this.getElementiSelezionati(filtroFrom);
      }
    });
  }

  getElementiSelezionati(formName: string) {
    if (!this._valoriFiltroSelezionati.length) {
      this.rimpiArraySelezionati(formName);
    } else {
      let arrayFiltrato: any;

      switch (formName) {
        case 'azione':
          arrayFiltrato = this.arrayAzioneBPSel;
          break;
        case 'kpi':
          arrayFiltrato = this.arrayKpiSel;
          break;
        default:
          break;
      }

      if (!arrayFiltrato) {
        return;
      }

      arrayFiltrato = arrayFiltrato.filter((elemento: any) => {
        return this._valoriFiltroSelezionati.every((valoreFiltro) => {
          if (valoreFiltro.chiave === 'titoloFiltroSelezione') {
            return elemento.titolo.toLowerCase().includes(valoreFiltro.values[0].toLowerCase()); // Controlla se il titolo include il valore
          } else if (valoreFiltro.chiave === 'descrizioneFiltroSelezione') {
            return elemento.descrizione
              .toLowerCase()
              .includes(valoreFiltro.values[0].toLowerCase()); // Controlla se il descrizione include il valore
          } else if (valoreFiltro.chiave === 'tagFiltroSelezione') {
            return valoreFiltro.values.some((valore) => elemento.tag?.includes(valore)); // Controlla se uno dei tag corrisponde
          } else if (valoreFiltro.chiave === 'nomeBreveFiltroSelezione') {
            return elemento.nomeBreve.toLowerCase().includes(valoreFiltro.values[0].toLowerCase()); // Controlla se il nome breve include il valore
          } else if (valoreFiltro.chiave === 'settoreFiltroSelezione') {
            return elemento.settori?.some((settore: any) =>
              valoreFiltro.values.includes(settore.id),
            ); // Controlla se almeno un settore corrisponde
          }

          return true; // Se il filtro non corrisponde a nessuna chiave, non filtrare
        });
      });

      switch (formName) {
        case 'azione':
          this.arrayAzioneBPSelFiltrati = arrayFiltrato;
          break;
        case 'kpi':
          this.arrayKpiSelFiltrati = arrayFiltrato;
          break;
        default:
          break;
      }
    }
  }

  public apriFiltro(filtroFrom: string) {
    // Uso un oggetto per mappare i casi e le funzioni corrispondenti
    const filterActions = {
      azione: () =>
        this._configuraFiltri(
          'titolo',
          'tag',
          'settori',
          this.metodoGetTagsPerChip(this.azioniBPService.getAzioneBPTags(0, 1000)),
        ),
      kpi: () =>
        this._configuraFiltri(
          'descrizione',
          'tag',
          'settori',
          this.metodoGetTagsPerChip(this.kpiService.getKPITags(0, 1000)),
        ),
    };

    // Tipo per le chiavi dell'oggetto filterActions
    type FilterActionsKey = keyof typeof filterActions;

    // Verifica se la chiave fornita è valida
    if (filtroFrom in filterActions) {
      this._filtri = filterActions[filtroFrom as FilterActionsKey]();
    }

    const dialogFiltro = this.dialog.open(DialogFiltroGenericoComponent, {
      data: {
        filtri: this._filtri,
        valoriFiltro: this._valoriFiltro,
      },
      panelClass: ['dialog-container'],
      disableClose: false,
      width: '50%',
      maxHeight: '95%',
      autoFocus: false,
    });

    dialogFiltro.afterClosed().subscribe((result) => {
      if (result) {
        this._valoriFiltro = result.filtri;

        switch (filtroFrom) {
          case 'azione':
            this._getAzioniBP();
            break;
          case 'kpi':
            this._getkPI();
            break;
          default:
            break;
        }
      }
    });
  }

  private _configuraFiltri(filtro1: string, filtro2: string, filtro3: string, metodoService: any) {
    return [
      {
        titolo: filtro1.includes('titolo') ? 'Titolo' : 'Descrizione',
        forControlName: filtro1,
        input: 'text',
        larghezza: 3,
      },
      {
        forControlName: filtro3,
        input: 'multiple-option',
        titolo: 'Settore',
        descValueOption: 'titolo',
        fnDatiOption: () =>
          this.settoriService.getSettori(0, 1000).pipe(map((value) => value?.content || [])),
        idValueOption: 'id',
        riempi: true,
      },

      {
        titolo: 'TAG',
        forControlName: filtro2,
        input: 'multiple-option-chip',
        riempi: true,
        larghezza: 3,
        fnDatiOption: metodoService,
        idValueOption: 'descrizione',
        descValueOption: 'descrizione',
        numeroRecOptions: Infinity,
      },
    ];
  }

  private _getAzioniBP() {
    this.loadingDisponibili = true;
    this.azioniBPService
      .getAzioneBP(0, 1000, undefined, this._valoriFiltro)
      .pipe(
        finalize(() => {
          setTimeout(() => {
            this.scrollSelezionate.update();

            this.scrollDispobibili.update();
            this.scrollDialog.update();
          }, 0);

          this.loadingDisponibili = false;
        }),
      )
      .subscribe({
        next: (esito) => {
          this.arrayAzioneBP = esito.content || [];

          //rimuovo le azioni e buone pratiche selezionati da quelli disponibili
          this.arrayAzioneBP = this.arrayAzioneBP.filter(
            (azioneSel) => !this.arrayAzioneBPSel.some((item2) => azioneSel.id === item2.id),
          );
        },
        error: (err) => {
          console.error(err);
        },
      });
  }
  private _getkPI() {
    this.loadingDisponibili = true;
    this.kpiService
      .getKPI(0, 1000, undefined, this._valoriFiltro)
      .pipe(
        finalize(() => {
          setTimeout(() => {
            this.scrollSelezionate.update();

            this.scrollDispobibili.update();
            this.scrollDialog.update();
          }, 0);

          this.loadingDisponibili = false;
        }),
      )
      .subscribe({
        next: (esito) => {
          this.arrayKpi = esito.content || [];

          //rimuovo kpi selezionati da quelli disponibili
          this.arrayKpi = this.arrayKpi.filter(
            (kpiSel) => !this.arrayKpiSel.some((item2) => kpiSel.id === item2.id),
          );
        },
        error: (err) => {
          console.error(err);
        },
      });
  }

  /**
   * Riempio l'array selezionati se faccio cancella filtri
   * @param formName
   */
  rimpiArraySelezionati(formName: string) {
    switch (formName) {
      case 'azione':
        this.arrayAzioneBPSelFiltrati = [...this.arrayAzioneBPSel];
        break;
      case 'kpi':
        this.arrayKpiSelFiltrati = [...this.arrayKpiSel];
        break;
      default:
        break;
    }
  }

  dropKpi(event: CdkDragDrop<KPI[]>) {
    const obj = this.dropElementi(event, this.arrayKpiSel, this.arrayKpiSelFiltrati);

    this.arrayKpiSel = obj.arrayElementiSel;
    this.arrayKpiSelFiltrati = obj.arrayElementiSelFiltrati;
  }

  dropAzioneBP(event: CdkDragDrop<AzioneBP[]>) {
    const obj = this.dropElementi(event, this.arrayAzioneBPSel, this.arrayAzioneBPSelFiltrati);

    this.arrayAzioneBPSel = obj.arrayElementiSel;
    this.arrayAzioneBPSelFiltrati = obj.arrayElementiSelFiltrati;
  }

  /**
   * Metodo generale che mi fa il drag and drop e sorting su liste filtrate e non.
   * @param event evento del drag & drop su quale azionare
   * @param arrayElementiSel
   * @param arrayElementiSelFiltrati
   * @returns oggetto con gli array calcolati
   */
  dropElementi(
    event: CdkDragDrop<any[]>,
    arrayElementiSel: any[],
    arrayElementiSelFiltrati: any[],
  ) {
    // Calcolo gli elementi nascosti dal filtro
    const elementiNascostiDalFiltro = arrayElementiSel.filter((elem1) => {
      return !arrayElementiSelFiltrati.some((elem2) => elem2.id === elem1.id);
    });

    // Funzione per ottenere indice non filtrato
    const getIndexNonFiltrato = (id: string) =>
      arrayElementiSel.findIndex((elem) => elem?.id === id);

    // Funzione per applicare il filtro iniziale
    const ripristinaFiltro = () => {
      arrayElementiSelFiltrati = arrayElementiSelFiltrati.filter((elem2) => {
        return !elementiNascostiDalFiltro.some((elem1) => elem1.id === elem2.id);
      });
    };

    const isSorting = event.previousContainer === event.container;
    const isAzioneSuSelezionati = event.container.data.every((item1) =>
      arrayElementiSel.some((item2) => item2.id === item1.id),
    );

    // Caso: Comportamento con filtro
    if (elementiNascostiDalFiltro.length) {
      if (isSorting) {
        // Sorting nella lista filtrata

        if (isAzioneSuSelezionati) {
          /*  Mi calcolo Index elemeno sulla lista non filtrata
             Perchè se ho filtrato vuoldire che gli indici in visualizzazione
             non corrispondono più con quelli originali per fare il sorting */
          const idForIdx = arrayElementiSelFiltrati[event.previousIndex]?.id;
          const findIdx = getIndexNonFiltrato(idForIdx);

          moveItemInArray(arrayElementiSel, findIdx, event.currentIndex);
          moveItemInArray(arrayElementiSelFiltrati, event.previousIndex, event.currentIndex);
        } else {
          moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
        }
      } else {
        // Sono in lista filtrata e faccio drag and drop

        if (isAzioneSuSelezionati) {
          // Drag and drop da DISPONIBILI a SELEZIONATI

          /* Prendo l'id dell elemento sopra a quello spostato, Per avere un riferimento di posizione 
             Questo perchè quando sposto un elemento lo posso rilasciare in qualsisi posizione, quindi 
            prendento un indice di riferimento, quando rimuovo i filtri, l'elemento spostato andra sotto quel
            indice di riferimento */
          const idElemSopra = arrayElementiSelFiltrati[event.currentIndex - 1]?.id;

          /* Tovo l'indice corretto per la lista non filtrata. Ovvero se nella lista filtratra ho spostato
           un elemento sotto [id : 1] allora mi prendo l'id del elemento sopra [id 1 - 1] e cerco l'id
           trovato l'id del elemento nella lista non fitlrata mi prendo index di spostamento sommando al indice trovato + 1 */
          const findIdx = getIndexNonFiltrato(idElemSopra) + 1;

          // Mi inserisco l'elemento nella posizione corretta nella lista non filtrata
          transferArrayItem(
            event.previousContainer.data,
            event.container.data,
            event.previousIndex,
            findIdx,
          );

          // Mi inserisco l'elemento anche nella lista filtrata, sul indice selezionato dall'interfaccia perhcè corrisponde.
          arrayElementiSelFiltrati.splice(event.currentIndex, 0, arrayElementiSel[findIdx]);

          // Rimuovo gli elementi nascosti per ritornare al filtro di prima
          ripristinaFiltro();
        } else {
          // Drag and drop da SELEZIONATI a DISPONIBILI

          // Mi trovo l'indice della lista non filtrata, questo perchè event.previousIndex mi risulta l'indice della lista filtrata
          const idxListaNonFiltrata = getIndexNonFiltrato(
            arrayElementiSelFiltrati[event.previousIndex].id,
          );

          //Rimuovo l'elemento che ho spostato dalla lista filtrata
          arrayElementiSelFiltrati = arrayElementiSelFiltrati.filter(
            (item) => item.id !== event.previousContainer.data[idxListaNonFiltrata].id,
          );

          // Trasferisco l'elemento con l'indice corretto
          transferArrayItem(
            event.previousContainer.data,
            event.container.data,
            idxListaNonFiltrata,
            event.currentIndex,
          );
        }
      }
    } else {
      // Caso: Comportamento regolare senza filtro
      arrayElementiSelFiltrati = arrayElementiSel; // stesso riferimento di memoria

      if (isSorting) {
        moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
      } else {
        transferArrayItem(
          event.previousContainer.data,
          event.container.data,
          event.previousIndex,
          event.currentIndex,
        );
      }
    }

    const obj = {
      arrayElementiSelFiltrati: arrayElementiSelFiltrati,
      arrayElementiSel: arrayElementiSel,
    };

    setTimeout(() => {
      this.scrollSelezionate.update();

      this.scrollDispobibili.update();
      this.scrollDialog.update();
    }, 0);

    return obj;
  }

  salva() {
    if (this.data.elemento === 'kpi') {
      this.dialogRef.close(this.arrayKpiSel);
    } else if (this.data.elemento === 'azione') {
      this.dialogRef.close(this.arrayAzioneBPSel);
    }
  }
}
